import { RangeSliderComponent } from './range-slider/range-slider.component';

export const Components = [
	RangeSliderComponent,
];
